<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<div class="flex flex-col gap-6">
  <div class="grid grid-cols-1 items-center gap-x-8 gap-y-4 lg:grid-cols-2">
    <div class="flex items-center gap-4">
      <ods-user-icon [initials]="profile().initials" [ariaLabel]="profile().name" />
      <h2 class="heading-2" data-test-id="profile-name">{{ profile().name }}</h2>
    </div>
    <administration-change-password-container class="justify-self-start" />
  </div>

  <dl class="grid grid-cols-1 gap-x-8 gap-y-6 lg:grid-cols-2">
    <div>
      <dt class="text-placeholder">Benutzername</dt>
      <dd data-test-id="profile-username">{{ profile().username }}</dd>
    </div>
    <div>
      <dt class="text-placeholder">E-Mail</dt>
      <dd class="break-words" data-test-id="profile-email">{{ profile().email }}</dd>
    </div>
    <div>
      <dt class="text-placeholder">Rollen</dt>
      <dd>
        @if (profile().roles.length > 0) {
          <ul class="list-outside list-disc pl-4" data-test-id="profile-roles">
            @for (role of profile().roles; track role) {
              <li data-test-class="profile-role">{{ role }}</li>
            }
          </ul>
        } @else {
          <p data-test-id="profile-no-roles-text">keine Rolle zugewiesen</p>
        }
      </dd>
    </div>
    <div>
      <dt class="text-placeholder">Organisationseinheiten</dt>
      <dd>
        @if (profile().organisationsEinheiten.length > 0) {
          <ul class="list-outside list-disc pl-4 break-words" data-test-id="profile-organisations-einheiten">
            @for (organisationsEinheit of profile().organisationsEinheiten; track organisationsEinheit) {
              <li data-test-class="profile-organisations-einheit">{{ organisationsEinheit }}</li>
            }
          </ul>
        } @else {
          <p data-test-id="profile-no-organisations-einheiten-text">keine zuständige Stelle zugewiesen</p>
        }
      </dd>
    </div>
  </dl>
</div>
